import { Fragment, useState, Suspense } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import ProgressBar from "../../components/molecules/progressBar/progressBar";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";

import UseStyles from "../dashboard/style";
import useStylesUnilens from "./style";
import HeaderBar from "../../components/molecules/headerBar/headerBar";
import UserMenu from "../../components/molecules/userMenu/userMenu";
import Navigaiton from "../../components/organisms/navigation/navigation";
import Hidden from "@material-ui/core/Hidden";
import MenuIcon from "@material-ui/icons/Menu";
import Nav from './components/nav/nav'

export default function BmpLayout({children}) {
    const { Navigation } = useSelector((state) => state);
    const [openNav, setOpenNav] = useState(false);
    const classes = UseStyles();
    const classesUnilens = useStylesUnilens();

    return (
        <Fragment>
            <Navigaiton
                className={classes.navigaitonBlock}
                openNav={openNav}
                setOpenNav={setOpenNav}
            />
            <div
                className={clsx(
                    classes.infoBoard,
                    {
                        [classes.infoBoardShift]: Navigation.isOpen,
                    },
                    classes.screen
                )}
            >
                <Hidden lgUp implementation="css">
                    <MenuIcon
                        className={classes.hamburger}
                        onClick={() => setOpenNav(!openNav)}
                    />
                </Hidden>

                <Suspense fallback={<ProgressBar />}>
                    <div className={classesUnilens.root}>
                        <CssBaseline />
                        <HeaderBar classes={classesUnilens}> 
                            <Grid container className={classesUnilens.wrappedBlock} alignItems="center">
                                <Grid container item className={classesUnilens.navStyleCustom}> {/* xs={12} sm={4} md={4} lg={4} */}
                                    {window.location.pathname === '/dashboard/brand-manager-portal' ? '' : <Nav />}
                                </Grid>
                                <Grid container item justifyContent="center" className={classesUnilens.centerTitle}> 
                                    <Typography variant="h1" className={classesUnilens.title}>Brand Manager Portal</Typography>
                                </Grid>
                                <Grid container item className={classesUnilens.userMenu}>
                                <UserMenu />
                                </Grid>
                            </Grid>
                        </HeaderBar>
                    </div>
                    <main>
                        {children}
                    </main>
                </Suspense>
            </div>
            
            
        </Fragment>
    )
}